import {CreateInstance} from './config'
const ApprovalsAPI = CreateInstance('approvals')
export default ApprovalsAPI
